import React, { useState } from "react";
import Typography from "../../../components/atoms/typography";
import { constants, labelStyle } from "../../../constants/pageConstants/pdpConstants";
import Accrodion from "../../../components/molecules/accordion";
import CustomImage from "../../../components/atoms/customImage";
import get from "lodash.get";
import AccordionContent from "../../../components/molecules/accordion/accordionContent";
import PropTypes from "prop-types";
import AccordionTitleHOC from "./AccordionTitleHOC";

/**
 * Component that represents a section of the accordion, displaying content based on the provided server data.
 * @param {Object} props - The component props.
 * @param {Array} props.productContent - The data to be displayed in the accordion section.
 * @returns {JSX.Element} The rendered AccordionSection component.
 */
const AccordionSection = ({ productContent }) => {
  const [activeIndex, setActiveIndex] = useState(-1);

  /**
   * Function to render an accordion icon alongside a label.
   * with a specific font size and weight.
   *
   * @param {string} label - The text label to be displayed next to the icon.
   * @param {string} icon - The source URL or path for the icon image.
   * @returns {JSX.Element} A JSX element containing the icon and label styled appropriately.
   */
  const renderAccordianIconAndLabel = (label, icon) => {
    return (
      <div className="flex items-center gap-12 py-3 text-14 font-500">
        <CustomImage src={icon} width={24} height={24} alt="" sizes="10vw" isPriority={false} />
        <div className="text-14 font-500 xxl:text-16">{label}</div>
      </div>
    );
  };
  return (
    <div>
      <Typography variant="p" Tag="p" classes={`${labelStyle} xxl:text-18`}>
        {constants.ABOUT_THE_PRODUCT}
      </Typography>
      <div className="productDescription ">
        <Accrodion key={"item.categoryName"}>
          {productContent?.productDescription && (
            <>
              <AccordionTitleHOC index={1} setActiveIndex={setActiveIndex} activeIndex={activeIndex}>
                {renderAccordianIconAndLabel(constants.PRODUCT_DESCRIPTION, "/icons/product-description.svg")}
              </AccordionTitleHOC>

              <AccordionContent activeIndex={activeIndex} index={1} styles="flex flex-col shadow-none px-1">
                <div className="descriptionTitle">
                  <div
                    dangerouslySetInnerHTML={{ __html: get(productContent, "productDescription") }}
                    itemProp="description"
                  />
                </div>
              </AccordionContent>
            </>
          )}
          {productContent?.careInstructions && (
            <>
              <AccordionTitleHOC index={2} setActiveIndex={setActiveIndex} activeIndex={activeIndex}>
                {renderAccordianIconAndLabel(constants.CARE_INSTRUCTIONS, "/icons/care-instructions.svg")}
              </AccordionTitleHOC>

              <AccordionContent activeIndex={activeIndex} index={2} styles="flex flex-col shadow-none px-1">
                <div className="descriptionTitle">
                  <div dangerouslySetInnerHTML={{ __html: get(productContent, "careInstructions") }} />
                </div>
              </AccordionContent>
            </>
          )}
          {productContent?.deliveryInfo && (
            <>
              <AccordionTitleHOC index={3} setActiveIndex={setActiveIndex} activeIndex={activeIndex}>
                {renderAccordianIconAndLabel(constants.DELIVERY_INFORMATION, "/icons/delivery-information.svg")}
              </AccordionTitleHOC>

              <AccordionContent activeIndex={activeIndex} index={3} styles="flex flex-col shadow-none px-1">
                <div className="descriptionTitle">
                  <div dangerouslySetInnerHTML={{ __html: get(productContent, "deliveryInfo") }} />
                </div>
              </AccordionContent>
            </>
          )}
        </Accrodion>
      </div>
    </div>
  );
};

AccordionSection.propTypes = {
  productContent: PropTypes.object.isRequired,
};

export default AccordionSection;
